import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Message, TreeNode } from 'primeng/api';
import { CategoriaPermissaoAgrupada } from 'src/app/admihair/api/dto/categoria-permissao-agrupada';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { Usuario } from 'src/app/admihair/api/dto/usuario';
import { CategoriaPermissaoService } from 'src/app/admihair/service/categoria-permissao.service';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UsuarioService } from 'src/app/admihair/service/usuario.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { AuthUtil } from 'src/app/admihair/util/auth-util';

@Component({
  selector: 'app-usuario-empresa-detalhar',
  templateUrl: './usuario-empresa-detalhar.component.html',
  styleUrls: ['./usuario-empresa-detalhar.component.scss']
})
export class UsuarioEmpresaDetalharComponent implements OnInit {

  loading: boolean = true;
  id?: number;
  usuario?: Usuario;
  empresa?: Empresa;
  messages: Message[] = [{ severity: '', summary: '', detail: '' }];
  messagemVisivel: boolean = false;

  colunasTreeTableSalvas: any[] = [];
  categoriasTreeTableSalvas: TreeNode[] = [];
  categoriasTreeTableSalvasSelecionada: TreeNode[] = [];

  constructor(private categoriaPermissaoService: CategoriaPermissaoService,
    private usuarioService: UsuarioService,
    private utilStorageService: UtilStorageService,
    private activatedRoute: ActivatedRoute,
    private erroService: ErroService
  ) { }

  ngOnInit(): void {
    this.carregarIdUsuario();
    this.empresa = this.utilStorageService.getEmpresa();
    this.inicializarColunas();
    this.carregarUsuarioPorId();
  }

  carregarIdUsuario(){
    const idParam = this.activatedRoute.snapshot.paramMap.get('id');
    if(idParam){
      this.id = parseInt(idParam);
    }
    
  }

  inicializarColunas() {
    this.colunasTreeTableSalvas = [
      { field: 'descricao', header: 'Permissão' }
    ];
  }


  carregarUsuarioPorId() {
    this.usuarioService.buscarPorId(this.id).subscribe({
      next: (data: Usuario) => {
        this.usuario = data;
        this.messagemVisivel = false;
        this.listarCategoriasSalvas();
      },
      error: (err: any) => {
        this.loading = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
      }
    });
  }

  listarCategoriasSalvas() {
    this.categoriaPermissaoService.listarAdicionadasPorUsuarioETipoEmpresa(this.empresa?.id, this.usuario?.id).subscribe({
      next: (data: CategoriaPermissaoAgrupada[]) => {
        this.categoriasTreeTableSalvas = this.converterParaTreeNode(data);
        this.loading = false;
      },
      error: (err: any) => {
        this.loading = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
      }
    });
  }
 

  converterParaTreeNode(categorias: CategoriaPermissaoAgrupada[]): TreeNode[] {
    return categorias.map(categoria => ({
      data: categoria,
      children: categoria.permissoes ? categoria.permissoes.map(permissao => ({
        data: permissao,
        leaf: true
      })) : []
    }));
  }

  verificarPermissao(nome: string): boolean{
    return AuthUtil.verificarPermissao(nome);
  }


}
